import { render } from "./AdvantageView.vue?vue&type=template&id=e3798194&scoped=true"
import script from "./AdvantageView.vue?vue&type=script&lang=js"
export * from "./AdvantageView.vue?vue&type=script&lang=js"

import "./AdvantageView.vue?vue&type=style&index=0&id=e3798194&lang=scss&scoped=true"

import exportComponent from "D:\\software\\phpEnv\\www\\hkz-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3798194"]])

export default __exports__